module.exports = __webpack_public_path__ + "static/media/08.022.3f94c19a.webp";